import { createRouter, createWebHashHistory } from 'vue-router'

import pinia from '@/store'
import { useAuthStore } from '@/store/auth'
import { useConfigStore } from '@/store/config'
import { useStatusStore } from '@/store/status'

import { routes } from './routes'

export const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.beforeEach((to, _, next) => {
  const auth = useAuthStore(pinia)
  const status = useStatusStore(pinia)
  const config = useConfigStore(pinia)
  const needsAuth =
    !['login', 'signUp', 'redirectLogin', 'supportLogin', 'demoPos', 'newPassword'].includes(
      to.name?.toString() || ''
    ) &&
    ![
      '/pos/login',
      '/pos/signUp',
      '/redirect-login',
      '/support-login',
      '/demo-pos',
      '/new-password'
    ].includes(to.path)
  const isAuthenticated = auth.isAuthenticated
  const gracePeriodExpired = auth.gracePeriodExpired
  const trialExpired = auth.trialExpired
  const hasTimeError = status.hasTimeError
  const isDeviceDeprecated = config.deviceIsDeprecated

  if (needsAuth && !isAuthenticated) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
  } else if (needsAuth && gracePeriodExpired && to.name !== 'gracePeriodExpired') {
    next({
      name: 'gracePeriodExpired'
    })
  } else if (needsAuth && trialExpired && to.name !== 'freeTrialExpired') {
    next({
      name: 'freeTrialExpired'
    })
  } else if (hasTimeError && to.name !== 'wrongTime') {
    next({
      name: 'wrongTime'
    })
  } else if (isDeviceDeprecated && to.name !== 'updateDevice') {
    next({
      name: 'updateDevice'
    })
  } else {
    next()
  }
})
